import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-avt-matiere',
  templateUrl: './avt-matiere.component.html',
  styleUrls: ['./avt-matiere.component.scss']
})
export class AvtMatiereComponent implements OnInit {

  constructor(public generalService : GeneralService, public route : ActivatedRoute, public router : Router) { }
  exist :boolean = true;
  listeAllMatiereIsLoadet :boolean = false;
  dsParametre
  parametre;
  listeMatiere = [];
  param_code : string;
  typeTrs : string;
  // le composon AvtMatiere peut etre ouvrir en modale, 
  // dans ce ca je veux que le bouton liste matiere ne s'affiche pas
  showBtnListeMatiere = this.generalService.showBtnListeMatiere
  ngOnInit()
  {
    this.parametre = {};
    this.init()
  }
  getDsParametre(url)
  {
    this.generalService.rechercheTable(url).subscribe(data =>
    {
      this.dsParametre = data;
      this.parametre = this.dsParametre.DiverSys[0];
      this.parametre.DiverSys_Type = "MAT01";
      this.exist = true;
    })
  }
  close()
  {
    this.generalService.dialog.closeAll()
  }
  enregister()
  {
    if(this.generalService.isNotEmpty(this.parametre.DiverSys_Titre))
    {
      if(this.generalService.isNotEmpty(this.dsParametre))
      {
        this.exist = false;
        // recherche du dernier code inserer
        this.generalService.rechercheTable("ds/formdata?code=DiverSys&val=MAT01").subscribe(data =>
        {
          this.listeMatiere = data.DiverSys;
          this.listeAllMatiereIsLoadet = true;
          this.parametre.DiverSys_Index = (this.listeMatiere.map(matiere => matiere.DiverSys_Index).reduce(function(a,b) {return Math.max(a, b);})+1)
          this.generalService.enregisterTable(this.dsParametre).subscribe(data =>
          {
            this.dsParametre = null;
            this.getDsParametre("ds/formdata?code=DiverSys");
            this.exist = true;
            this.generalService.dialogSuccess("enregistré",true)
          },
          ()=>
          {
            this.exist = true;
            this.generalService.dialogSuccess("Non enregistré",false)
          })
        },
        ()=>
        {
          this.exist = true;
          this.generalService.dialogSuccess("Non enregistré",false)
        });
      }
      else
        this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des données",false);
    }
  }
  
  init()
  {
    this.getDsParametre("ds/formdata?code=DiverSys");
  }
}
